import styles from "./m3.module.css";

/**
 * Placeholder for an empty list, table or panel: icon, title, explanation, actions.
 *
 * @param {boolean} plain - no dashed border or background, for use inside an existing card
 */
const EmptyState = ({ icon, title, description, actions, plain = false }) => (
  <div className={`${styles.empty} ${plain ? styles.emptyPlain : ""}`}>
    {icon && <span className={styles.emptyIcon}>{icon}</span>}
    {title && <p className={styles.emptyTitle}>{title}</p>}
    {description && <p className={styles.emptyDesc}>{description}</p>}
    {actions && <div className={styles.emptyActions}>{actions}</div>}
  </div>
);

export default EmptyState;
